import React from 'react';
import { H6 } from '@finect/tabular-core/Headings';
import { Video } from '../../../Videos';
import { Inner, VideoBlock } from './partials';
export var VideoListItem = function VideoListItem(_ref) {
  var video = _ref.video,
    onAction = _ref.onAction;
  var handleClick = function handleClick() {
    onAction && onAction(video);
  };
  return React.createElement(Inner, {
    onClick: handleClick
  }, React.createElement(VideoBlock, null, React.createElement(Video, {
    playIconSize: "medium",
    video: video.body.url
  })), React.createElement("div", null, React.createElement(H6, null, video.title)));
};